import { render, staticRenderFns } from "./PostalCodeModal.vue?vue&type=template&id=14c69127&"
import script from "./PostalCodeModal.vue?vue&type=script&lang=js&"
export * from "./PostalCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports